import guards from './guards';

const Step1 = () =>
    import(/* webpackChunkName: "marketing-bundle" */ '@S/Marketing/Step1.vue');
const Step2 = () =>
    import(/* webpackChunkName: "marketing-bundle" */ '@S/Marketing/Step2.vue');
const Step3 = () =>
    import(/* webpackChunkName: "marketing-bundle" */ '@S/Marketing/Step3.vue');
const Complete = () =>
    import(/* webpackChunkName: "marketing-bundle" */ '@S/Marketing/Complete.vue');
const Verify = () =>
    import(/* webpackChunkName: "marketing-bundle" */ '@S/Marketing/Verify.vue');

export default [
    {
        path: '/marketing/step1',
        name: 'Marketing Step 1',
        component: Step1,
        beforeEnter: guards.marketingStep
    },
    {
        path: '/marketing/step2',
        name: 'Marketing Step 2',
        component: Step2,
        beforeEnter: guards.marketingStep
    },
    {
        path: '/marketing/step3',
        name: 'Marketing Step 3',
        component: Step3,
        beforeEnter: guards.marketingStep
    },
    {
        path: '/marketing/complete',
        name: 'Marketing Complete',
        component: Complete,
        beforeEnter: guards.marketingStep
    },
    {
        path: '/marketing/verify',
        name: 'Marketing Verify',
        component: Verify,
        beforeEnter: guards.verifyCallback
    }
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/marketing.js